'use client'

import { type AccountBottomNavigation as AccountBottomNavigationType } from 'cms-types'
import { useMemo } from 'react'
import { AccountBottomNavigation as AccountBottomNavigationUI } from 'ui'

import { CLUB_PAGE_URL, SET_CREATOR_PAGE_URL } from '@/helpers/club'
import { useCanSeeClub } from '@/hooks/useCanSeeClub'
import { useCanSeeWunschset } from '@/hooks/useCanSeeWunschset'

import { pageToUrl } from '../helpers'

type AccountBottomNavigationProps = AccountBottomNavigationType & {
  profileName?: string
}

export default function AccountBottomNavigation({
  menu,
  profileName,
}: AccountBottomNavigationProps) {
  const canSeeClub = useCanSeeClub()
  const canSeeWunschset = useCanSeeWunschset()

  const items = useMemo(
    () =>
      [
        {
          id: 'profile',
          title: profileName ?? 'Profile',
          icon: 'MdPerson',
          url: '/account',
        },
        ...(menu?.map(({ icon, title, page, id }) => ({
          id,
          title,
          icon,
          url: pageToUrl(page) ?? '',
        })) ?? []),
        // Hide the club entry from non-eligible customers during the release phase,
        // and the Wunschset entry from non-members (gated by the Club:Member tag).
      ].filter(
        item =>
          Boolean(item.url) &&
          (canSeeClub || item.url !== CLUB_PAGE_URL) &&
          (canSeeWunschset || item.url !== SET_CREATOR_PAGE_URL),
      ),
    [menu, profileName, canSeeClub, canSeeWunschset],
  )

  return (
    <AccountBottomNavigationUI
      items={items}
      visiblePathPrefixes={['/account', '/shop/wunschset']}
      ariaLabel='Account'
    />
  )
}
